import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

const thresholds = [
  { l: 's', r: 59, d: 'second' },
  { l: 'm', r: 119, d: 'second' },
  { l: 'mm', r: 59, d: 'minute' },
  { l: 'h', r: 1 },
  { l: 'hh', r: 23, d: 'hour' },
  { l: 'd', r: 1 },
  { l: 'dd', r: 29, d: 'day' },
  { l: 'M', r: 1 },
  { l: 'MM', r: 11, d: 'month' },
  { l: 'y', r: 1 },
  { l: 'yy', d: 'year' },
];

const config = {
  thresholds,
  rounding: Math.floor,
};

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime, config);
dayjs.extend(advancedFormat);

const customRelativeTime = {
  en: {
    future: 'in %s',
    past: '%s ago',
    s: '<1 min',
    m: '1 min',
    mm: '%d min',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
  es: {
    future: 'en %s',
    past: '%s atrás',
    s: '<1 min',
    m: '1 min',
    mm: '%d min',
    h: '1 hora',
    hh: '%d horas',
    d: '1 día',
    dd: '%d días',
    M: '1 mes',
    MM: '%d meses',
    y: '1 año',
    yy: '%d años',
  },
  pt: {
    future: 'em %s',
    past: '%s atrás',
    s: '<1 min',
    m: '1 min',
    mm: '%d min',
    h: '1 hora',
    hh: '%d horas',
    d: '1 dia',
    dd: '%d dias',
    M: '1 mês',
    MM: '%d meses',
    y: '1 ano',
    yy: '%d anos',
  },
};

dayjs.updateLocale('en', { relativeTime: customRelativeTime.en });
dayjs.updateLocale('es', { relativeTime: customRelativeTime.es });
dayjs.updateLocale('pt', { relativeTime: customRelativeTime.pt });
